import { render, staticRenderFns } from "./AnomalySummaryView.vue?vue&type=template&id=a8e60292&scoped=true&"
import script from "./AnomalySummaryView.vue?vue&type=script&lang=js&"
export * from "./AnomalySummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e60292",
  null
  
)

export default component.exports